/** @format */
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { _$, FormItem, Icon, Select, Option } from '@king-design/react'
import { SelectInput } from 'src/components'
import variable from 'src/static/styles/var'
import { cloneDeep } from 'lodash'

export const initEvents: EventParams[] = [
  {
    EventName: '',
    EventDesc: '',
    EventTags: [
      {
        TagName: '',
        TagValue: ''
      }
    ]
  }
]

interface EventParams {
  EventName: string
  EventDesc: string
  EventTags: { TagName: string; TagValue: string }[]
}

interface SelectEventTagsProps {
  className?: string
  index: number
  productType: number
  event: EventParams
  eventList: any[]
  selectedEvents: any[]
  changeEvent: (values: EventParams) => void
  addEvent: () => void
  removeEvent: (index: number) => void
}

const SelectEventTags: FC<SelectEventTagsProps> = ({
  className,
  index,
  productType,
  event,
  eventList,
  selectedEvents,
  changeEvent,
  addEvent,
  removeEvent
}) => {
  const { EventName, EventTags } = event

  const eventOpts = useMemo(() => {
    if (eventList?.length && productType !== undefined) {
      return eventList.filter(item => item.productType === productType)
    } else {
      return []
    }
  }, [eventList, productType])

  const tagOpts = useMemo(() => {
    if (EventName && eventList?.length) {
      return eventList.find(({ name }) => name === EventName)?.eventTags || []
    } else {
      return []
    }
  }, [EventName, eventList])

  const addTags = () => {
    const initTags = cloneDeep(initEvents[0].EventTags[0])
    changeEvent({
      ...event,
      EventTags: [...EventTags, initTags]
    })
  }

  const removeTags = index => {
    const cloneTags = cloneDeep(EventTags)
    cloneTags.splice(index, 1)
    changeEvent({
      ...event,
      EventTags: cloneTags
    })
  }

  return (
    <div className={className}>
      <div className="event_select">
        <FormItem label="事件" hideLabel className="margin_left" value={EventName}>
          <Select
            width={500}
            value={EventName}
            filterable
            placeholder={_$('请选择事件')}
            onChangeValue={value => {
              const findEvent = eventList.find(({ name }) => name === value)
              if (findEvent) {
                changeEvent({
                  EventName: value,
                  EventDesc: findEvent.nameDesc,
                  EventTags: []
                })
              }
            }}
          >
            {eventOpts?.length
              ? eventOpts.map(item => {
                  const { name, nameDesc } = item
                  const disabled = selectedEvents.find(
                    (event, i) => index !== i && event.EventName === name
                  )
                  return (
                    <Option key={name} value={name} disabled={!!disabled}>
                      {nameDesc}
                    </Option>
                  )
                })
              : null}
          </Select>
        </FormItem>
        {index === selectedEvents?.length - 1 ? (
          <Icon
            className="ion-plus-circled primary-color"
            size={18}
            onClick={() => {
              addEvent()
            }}
          />
        ) : null}
        {selectedEvents?.length > 1 ? (
          <Icon
            className="ion-trash-a primary-color"
            size={20}
            onClick={() => {
              removeEvent(index)
            }}
          />
        ) : null}
      </div>

      {tagOpts?.length ? (
        <div className="tag_select">
          {EventTags?.map(({ TagName, TagValue }, index) => {
            return (
              <div className="tag_select_item" key={index}>
                <FormItem label={_$('维度')} className="tag_margin_left">
                  <SelectInput
                    placeholder="请输入TagValue，默认全部生效，多个值使用,隔开"
                    width={350}
                    value={TagValue}
                    selectProps={{
                      width: 130,
                      value: TagName,
                      placeholder: _$('维度'),
                      clearable: true
                    }}
                    options={tagOpts?.map(({ tagName }) => {
                      const disabled = EventTags.find(
                        (item, i) => index !== i && item.TagName === tagName
                      )
                      return (
                        <Option key={tagName} value={tagName} disabled={!!disabled}>
                          {tagName}
                        </Option>
                      )
                    })}
                    onChange={(inputvalue, selectvalue) => {
                      const cloneTags = cloneDeep(EventTags)
                      cloneTags[index].TagName = selectvalue
                      cloneTags[index].TagValue = inputvalue
                      changeEvent({
                        ...event,
                        EventTags: cloneTags
                      })
                    }}
                  />
                  {/* <Select
                    width={120}
                    value={TagName}
                    placeholder={_$('维度')}
                    clearable
                    onChangeValue={value => {
                      const cloneTags = cloneDeep(EventTags)
                      cloneTags[index].TagName = value
                      changeEvent({
                        ...event,
                        EventTags: cloneTags
                      })
                    }}
                  >
                    {tagOpts?.map(({ tagName }) => {
                      const disabled = EventTags.find(
                        (item, i) => index !== i && item.TagName === tagName
                      )
                      return (
                        <Option key={tagName} value={tagName} disabled={!!disabled}>
                          {tagName}
                        </Option>
                      )
                    })}
                  </Select> */}
                </FormItem>
                {/* <FormItem hideLabel>
                  <Input
                    placeholder="请输入TagValue，默认全部生效，多个值使用,隔开"
                    width={350}
                    value={TagValue}
                    onChangeValue={value => {
                      const cloneTags = cloneDeep(EventTags)
                      cloneTags[index].TagValue = value
                      changeEvent({
                        ...event,
                        EventTags: cloneTags
                      })
                    }}
                  />
                </FormItem> */}
                <Icon
                  className="ion-trash-a primary-color"
                  size={20}
                  onClick={() => {
                    removeTags(index)
                  }}
                />
              </div>
            )
          })}
          {EventTags?.length < tagOpts?.length ? (
            <a
              className="add_tag_btn"
              onClick={() => {
                addTags()
              }}
            >
              <Icon className="ion-plus-round"></Icon>
              {_$('添加维度')}
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default styled(SelectEventTags)`
  .margin_left {
    margin-left: 100px;
  }
  .tag_margin_left {
    margin-left: 30px;
  }
  .event_select {
    display: flex;
    margin-bottom: 20px;
    .k-icon {
      margin-left: 8px;
      line-height: 32px;
      transition: all ease-in-out 0.3s;
      &:hover {
        color: ${variable.primaryColor};
      }
    }
  }
  .tag_select {
    .tag_select_item {
      display: flex;
      margin-bottom: 10px;
    }
    .k-icon {
      margin-left: 16px;
      cursor: pointer;
      line-height: 32px;
      transition: all ease-in-out 0.3s;
      &:hover {
        color: ${variable.primaryColor};
      }
    }
    .add_tag_btn {
      display: inline-flex;
      align-items: center;
      margin-left: 85px;
      margin-bottom: 20px;
      height: 20px;
      .k-icon {
        margin-right: 4px;
      }
    }
  }
  .k-form-item:not(:last-of-type) {
    margin-bottom: 0;
  }
`
